<template>
  <div class="container ingreso-manual">
    <div class="header">
      <div id="navigation-back" @click.prevent="back">
        <figure id="back-figure">
          <img src="../../static/img/back.png" alt="Volver">
        </figure>
      </div>
      <div id="navigation-home" @click.prevent="goInicio">
        <figure id="home-figure">
            <img src="../../static/img/home.png" alt="Inicio">
        </figure>
      </div>
    </div>
    <div class="section">
      <div class="logo">
        <figure>
          <img src="../assets/logo.png" alt="DIRECTV">
        </figure>
      </div>
      <div class="documento">
        <p v-show="!displayMsj" :class="{ displayNumberError: numberError }">{{ documentoDisplay }}</p>
        <p v-show="displayMsj" :class="{ displayMsjError: displayError }">{{ documentoMensaje }}</p>
      </div>
      <div class="teclado-cel">
        <div class="teclado-cel-row">
          <div id='1' @click='click' class="teclado-cel-col">1</div>
          <div id='2' @click='click' class="teclado-cel-col">2</div>
          <div id='3' @click='click' class="teclado-cel-col">3</div>
        </div>
        <div class="teclado-cel-row">
          <div id='4' @click='click' class="teclado-cel-col">4</div>
          <div id='5' @click='click' class="teclado-cel-col">5</div>
          <div id='6' @click='click' class="teclado-cel-col">6</div>
        </div>
        <div class="teclado-cel-row">
          <div id='7' @click='click' class="teclado-cel-col">7</div>
          <div id='8' @click='click' class="teclado-cel-col">8</div>
          <div id='9' @click='click' class="teclado-cel-col">9</div>
        </div>
        <div class="teclado-cel-row">
          <div id='clear' @click='click' class="teclado-cel-col">Clear</div>
          <div id='0' @click='click' class="teclado-cel-col">0</div>
          <div id='delete' @click='click' class="teclado-cel-col">Del</div>
        </div>
      </div>
      <b-button class="link"
        @click.prevent="save">ENVIAR</b-button>
    </div>
    <b-alert
      v-model="error"
      variant= "warning">
      <p>{{ errorMessage }}</p>
    </b-alert>    
  </div>
</template>

<script>

export default {
  data () {
    return {
      evento: null,
      eventoNombre: '',
      displayError: false,
      displayMsj: true,
      documentoNumero: '',
      documentoDisplay: '',
      numberError: false,
      documentoMensaje: 'Ingrese el nro. de documento',
      error: false,
      errorMessage: ''
    }
  },
  created () {
    if (!this.$store.getters['settings/testing']) {
      if (!this.$store.getters['user/loggedIn']) {
        this.$router.push({ name: 'Login' });
      }

      this.evento = this.$store.getters['eventos/evento'];
      if (this.evento) {
        this.eventoNombre = this.evento.nombre;
      }
      if (!this.evento) {
        this.$router.push({ name: 'SeleccionEvento' });
      }
    }
  },
  methods: {
    save () {
      this.error = false;
      this.errorMessage = '';

      if ( this.documentoNumero.trim() != '') {
        if (isNaN(this.documentoNumero)) {
          this.error = true;
          this.errorMessage = 'Ingrese solo digitos numéricos';
          return;
        } 
        if (!isFinite(this.documentoNumero)) {
            this.error = true;
            this.errorMessage = 'Ingrese solo digitos numéricos';
            return;
        }
        /* Validamos la longitud del nro de documento */
        if (this.documentoNumero.length < 7 || this.documentoNumero.length > 8) {
            this.error = true;
            this.errorMessage = 'Verifique el nro de documento ingresado';
            return;
        }

        this.$store.dispatch('participante/setDocumentoParticipante', this.documentoNumero)
          .then(() => this.$router.push({ name: 'IngresoManualSexo' }))
          .catch( error => {
            this.error = true;
            this.errorMessage = error;
          });
      } else {
        this.documentoMensaje = 'Ingrese el nro de documento';
        this.displayError = true;
        this.displayMsj = true;
      }
    },
    back () {
      this.$router.go(-1)
    },
    goInicio () {
      this.$router.push({ name: 'Inicio' });
    },
    click(event) {
      if (event) {
        if (event.srcElement) {
          if (this.displayMsj) {
            this.documentoNumero = '';
            this.displayMsj = false;
            this.displayError = false;
          }

          if (event.target.innerText == 'Clear') {
            this.documentoNumero = '';      
          } else if (event.target.innerText == 'Del') {
            this.documentoNumero = this.documentoNumero.substring(0, this.documentoNumero.length - 1);      
          } else {
            this.documentoNumero += event.target.innerText;      
          }

          this.numberError = false;
          this.error = false;
          this.errorMessage = '';
          var long = this.documentoNumero.length;
          if (long <= 3) {
            this.documentoDisplay = this.documentoNumero;
          } else if (long <= 6) {
            var miles = long - 3;
            this.documentoDisplay = this.documentoNumero.substring(0, miles)
              + '.' + this.documentoNumero.substring(miles);
          } else if (long <= 8) {
            var millones = long - 6;
            this.documentoDisplay = this.documentoNumero.substring(0, millones)
              + '.' + this.documentoNumero.substring(millones, millones + 3)
              + '.' + this.documentoNumero.substring(millones + 3);
          } else {
            this.documentoDisplay = this.documentoNumero;
            this.numberError = true;
          }

        }
      }
    }
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/IngresoManualTeclado.vue